import { render, staticRenderFns } from "./DialogHistoryReasonAutorization.vue?vue&type=template&id=01b5a21f&scoped=true&"
import script from "./DialogHistoryReasonAutorization.vue?vue&type=script&lang=js&"
export * from "./DialogHistoryReasonAutorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5a21f",
  null
  
)

export default component.exports